import React, { useEffect, useState } from 'react';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import Swal from 'sweetalert2';
import ViewImageAndText from '../../components/ViewImageAndText';
import { CModal } from '@coreui/react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import { generateAxiosInstanceInstitute } from '../../hooks/useAuthorizedRequestForInstitute';
import { generateAxiosInstanceCommonFileUpload } from '../../hooks/useAuthorizedRequestForFileUpload';
import { useNavigate } from 'react-router-dom';
import { Loader } from '../../components/ModalsCommonFunctions';
import { deleteItem, findPageNumber, searchArray, SortIcon } from '../../components/Navigation';
import Pagination from '../../components/Pagination';
import ViewImageAndTextQuetionBank from '../../components/ViewImageAndTextQuetionBank';
import VidyaUpasnaLogo from '../../assets/VidyaUpasna.jpg';

const InstituteViewCompetitiveExam = () => {
    let instituteMasterId = localStorage.getItem("instituteMasterId")
    const instituteName = localStorage.getItem("instituteName");
    const instituteLogo = localStorage.getItem("logoPath");
    const authorizedAxiosInstitute = generateAxiosInstanceInstitute()
    const authorizedAxiosCommonFileUpload = generateAxiosInstanceCommonFileUpload()
    const [questions, setQuestion] = useState([]);
    const [editId, setEditId] = useState(null);
    const [syllabusList, setSyllabusList] = useState([]);
    const [subjectList, setSubjectList] = useState([])
    const [topicList, setTopicList] = useState([])
    const [lessonList, setLessonList] = useState([])
    const [subtopicList, setSubtopicList] = useState([])
    const [bookList, setBookList] = useState([])
    const [visible, setVisible] = useState(false)
    const [modalData, setModalData] = useState("")
    const navigate = useNavigate();

    // const initialFormState = {
    //     q_level: '',
    //     q_type: '',
    //     question: '',
    //     option_a: '',
    //     option_b: '',
    //     option_c: '',
    //     option_d: '',
    //     ans: '',
    //     sol: ''
    // }

    const initialFilterState = {
        instituteCompetitiveExamNameMasterId: '',
        instituteCompetitiveExamBookMasterId: '',
        instituteCompetitiveLessonMasterId: '',
        instituteCompetitiveTopicMasterId: '',
        instituteCompetitiveSubTopicMasterId: '',
        instituteSubjectMasterId: ''
    }

    const [filter, setFilter] = useState(initialFilterState);
    // const [editAns, setEditAns] = useState(initialFormState);
    const [visibleImage, setVisibleImage] = useState(false);
    const [modalImageSrc, setModalImageSrc] = useState('');

    const [startIndex, setStartIndex] = useState(null);
    const [currPage, setCurrPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [displayedData, setDisplayedData] = useState([]);
    const [totalPages, setTotalPages] = useState(0);
    const [saveId, setSaveId] = useState(null);

    const [searchValue, setSearchValue] = useState(null);
    const searchKeys = ["q_level", "q_type", "question", "option_a", "option_b", "option_c", "option_d", "ans"];

    const [loading, setLoading] = useState(false);
    const handleNavigate = (route) => {
        navigate(route);
    };

    const onViewImage = (imgSrc) => {
        setModalImageSrc(imgSrc);
        setVisibleImage(true);
    };

    useEffect(() => {
        getSyllabusList();
    }, []);

    useEffect(() => {
        if (searchValue === '' && searchValue !== null) {
            setCurrPage(1);
            getQuestionAnswerList();
        }
    }, [searchValue]);

    const handleEmptySearch = (e) => {
        setSearchValue(e.target.value);
    }

    const handleSearch = async () => {
        if (searchValue !== null) {
            setQuestion(await searchArray("I", getApiUrl(), searchKeys, searchValue.trim(), "data"))
        }
    }

    useEffect(() => {
        if (saveId) {
            const pageNumber = findPageNumber(questions, saveId, itemsPerPage);
            setCurrPage(pageNumber);
        }
    }, [saveId])

    useEffect(() => {
        setTotalPages(Math.ceil(questions.length / itemsPerPage));
        const startIndex = (currPage - 1) * itemsPerPage;
        let endIndex = startIndex + itemsPerPage;

        if (endIndex > questions.length) {
            endIndex = questions.length;
        }
        setStartIndex(startIndex);
        setDisplayedData(questions.slice(startIndex, endIndex));
    }, [questions, currPage, itemsPerPage]);

    useEffect(() => {
        if (filter.instituteCompetitiveExamNameMasterId.length !== 0 && filter.instituteCompetitiveExamBookMasterId.length !== 0 && filter.instituteSubjectMasterId.length !== 0) {
            getQuestionAnswerList();
        }
    }, [filter]);

    const getApiUrl = () => {
        let apiUrl = `/get-institute-competitive-question-bank?instituteMasterId=${instituteMasterId}&`;
        if (filter.instituteCompetitiveExamNameMasterId) {
            apiUrl += `instituteCompetitiveExamNameMasterId=${filter.instituteCompetitiveExamNameMasterId}&`;
        }
        if (filter.instituteCompetitiveExamBookMasterId) {
            apiUrl += `instituteCompetitiveExamBookMasterId=${filter.instituteCompetitiveExamBookMasterId}&`
        }
        if (filter.instituteCompetitiveLessonMasterId) {
            apiUrl += `instituteCompetitiveLessonMasterId=${filter.instituteCompetitiveLessonMasterId}&`;
        }
        if (filter.instituteCompetitiveTopicMasterId) {
            apiUrl += `instituteCompetitiveTopicMasterId=${filter.instituteCompetitiveTopicMasterId}&`;
        }
        if (filter.instituteCompetitiveSubTopicMasterId) {
            apiUrl += `instituteCompetitiveSubTopicMasterId=${filter.instituteCompetitiveSubTopicMasterId}&`;
        }
        if (filter.instituteSubjectMasterId) {
            apiUrl += `instituteSubjectMasterId=${filter.instituteSubjectMasterId}&`;
        }

        apiUrl = apiUrl.replace(/&$/, '');
        return apiUrl;
    }

    const getQuestionAnswerList = async () => {
        if (filter.instituteCompetitiveExamNameMasterId.length !== 0 && filter.instituteCompetitiveExamBookMasterId.length !== 0 && filter.instituteSubjectMasterId.length !== 0) {
            try {
                const response = await authorizedAxiosInstitute.get(getApiUrl());
                setQuestion(response.data.data)
            } catch (error) {
                setQuestion([]);
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            }
        }
    }

    const getSyllabusList = () => {
        const apiUrlForSyllabus = `/get-institute-competitive-exam-names?instituteMasterId=${instituteMasterId}`;
        authorizedAxiosInstitute && authorizedAxiosInstitute.get(apiUrlForSyllabus)
            .then(response => {
                setSyllabusList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleInputFilterChange = (e) => {
        const { name, value } = e.target;
        setFilter((prevData) => {
            return {
                ...prevData,
                [name]: value
            }
        })
    }

    const handleSyllabusChange = (e) => {
        setFilter((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value,
                instituteCompetitiveExamBookMasterId: '',
                instituteSubjectMasterId: '',
                instituteCompetitiveLessonMasterId: '',
                instituteCompetitiveTopicMasterId: '',
                instituteCompetitiveSubTopicMasterId: ''
            }
        })

        const apiUrl2 = `/get-institute-competitive-exam-book-master?instituteCompetitiveExamNameMasterId=${e.target.value}`;
        authorizedAxiosInstitute && authorizedAxiosInstitute.get(apiUrl2)
            .then(response => {
                setBookList(response.data.data)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleBookChanges = (e) => {
        setFilter((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value,
                instituteSubjectMasterId: '',
                instituteCompetitiveLessonMasterId: '',
                instituteCompetitiveTopicMasterId: '',
                instituteCompetitiveSubTopicMasterId: ''
            }
        })

        const apiUrl2 = `/get-institute-competitive-exam-book-wise-subject?instituteCompetitiveExamBookMasterId=${e.target.value}`;
        authorizedAxiosInstitute && authorizedAxiosInstitute.get(apiUrl2)
            .then(response => {
                setSubjectList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleSubjectChanges = (e) => {
        setFilter((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value,
                instituteCompetitiveLessonMasterId: '',
                instituteCompetitiveTopicMasterId: '',
                instituteCompetitiveSubTopicMasterId: ''
            }
        })

        const apiUrl = `/get-institute-competitive-lesson-master?instituteMasterId=${instituteMasterId}&instituteCompetitiveExamBookMasterId=${filter.instituteCompetitiveExamBookMasterId}&instituteSubjectMasterId=${e.target.value}`;
        authorizedAxiosInstitute && authorizedAxiosInstitute.get(apiUrl)
            .then(response => {
                setLessonList(response.data.result)
            })
            .catch(error => {
                setLessonList(error?.response?.data.result);
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleLessonChange = (e) => {
        setFilter((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value,
                instituteCompetitiveTopicMasterId: '',
                instituteCompetitiveSubTopicMasterId: ''
            }
        })
        const apiUrl = `/get-institute-competitive-topic-master?instituteMasterId${instituteMasterId}&instituteCompetitiveLessonMasterId=${e.target.value}`;
        authorizedAxiosInstitute && authorizedAxiosInstitute.get(apiUrl)
            .then(response => {
                setTopicList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleTopicChange = (e) => {
        setFilter((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value,
                instituteCompetitiveSubTopicMasterId: ''
            }
        })
        const apiUrl = `/get-institute-competitive-sub-topic-master?instituteMasterId=${instituteMasterId}&instituteCompetitiveExamNameMasterId=${filter.instituteCompetitiveExamNameMasterId}&instituteCompetitiveExamBookMasterId=${filter.instituteCompetitiveExamBookMasterId}&instituteCompetitiveLessonMasterId=${filter.instituteCompetitiveLessonMasterId}&instituteCompetitiveTopicMasterId=${filter.instituteCompetitiveTopicMasterId}`;
        authorizedAxiosInstitute && authorizedAxiosInstitute.get(apiUrl)
            .then(response => {
                setSubtopicList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    // const handleInputChange = (e) => {
    //     setEditAns((prevData) => {
    //         return {
    //             ...prevData,
    //             [e.target.name]: e.target.value
    //         }
    //     })
    // }

    // const deleteSubtopic = async (id) => {
    //     let confirmed = window.confirm('Are you sure? you want to delete this record.');
    //     if (confirmed) {
    //         try {
    //             setLoading(true);
    //             const apiUrl = `/delete-institute-competitive-question-bank?id=${id}`;
    //             const response = await authorizedAxiosInstitute.delete(apiUrl)
    //             const page = deleteItem(currPage, itemsPerPage, questions.length);
    //             await getQuestionAnswerList();
    //             setCurrPage(page);
    //             setEditAns(initialFormState)

    //             Swal.fire(
    //                 { text: response.data.message }
    //             );
    //         } catch (error) {
    //             const errorMsg = error?.response?.data?.message || 'Something went wrong!';
    //             Swal.fire(
    //                 { text: errorMsg }
    //             );
    //         } finally {
    //             setLoading(false);
    //         }
    //     }
    // }

    // const updateSubtopic = async () => {
    //     try {
    //         setLoading(true);
    //         const apiUrl = `/edit-institute-competitive-question-bank?id=${editId}`;
    //         const response = await authorizedAxiosInstitute.put(apiUrl, editAns)
    //         await getQuestionAnswerList();
    //         setEditAns(initialFormState)
    //         setEditId(null);

    //         Swal.fire(
    //             { text: response.data.message }
    //         );
    //     } catch (error) {
    //         const errorMsg = error?.response?.data?.message || 'Something went wrong!';
    //         Swal.fire(
    //             { text: errorMsg }
    //         );
    //     } finally {
    //         setLoading(false);
    //     }
    // }

    // function uploadAdapter(loader) {
    //     return {
    //         upload: () => {
    //             return new Promise((resolve, reject) => {
    //                 const body = new FormData();
    //                 setLoading(true);
    //                 loader.file.then(async (file) => {
    //                     body.append("file", file);
    //                     const apiUrl = "uploadimage";
    //                     authorizedAxiosCommonFileUpload && authorizedAxiosCommonFileUpload.post(apiUrl, body)
    //                         .then((res) => {
    //                             resolve({ default: res.data.result });
    //                         })
    //                         .catch((err) => {
    //                             reject(err?.response?.data?.error);
    //                         })
    //                         .finally(() => {
    //                             setLoading(false); // End loading
    //                         });
    //                 });
    //             });
    //         },
    //     };
    // }

    // function uploadPlugin(editor) {
    //     editor.plugins.get("FileRepository").createUploadAdapter = (loader) => {
    //         return uploadAdapter(loader);
    //     };
    // }

    // const handleDetailChange = (editor) => {
    //     let value = editor.getData();
    //     setEditAns((prevData) => {
    //         return {
    //             ...prevData,
    //             sol: value
    //         }
    //     })
    // }

    const handleReset = () => {
        setFilter(initialFilterState);
        // setEditAns(initialFormState);
        setEditId(null);
        setBookList([]);
        setSubjectList([]);
        setLessonList([]);
        setTopicList([]);
        setSubtopicList([]);
        setQuestion([]);
        setVisible(false);
        setVisibleImage(false);
        setCurrPage(1);
        setItemsPerPage(10);
        setStartIndex(null);
        setTotalPages(0);
    }

    // useEffect(() => {
    //     if (questionLevelSort == true || questionLevelSort == false) {
    //         setQuestionTypeSort(null);
    //         setQuestionSort(null);
    //     }
    // }, [questionLevelSort])

    // useEffect(() => {
    //     if (questionTypeSort == true || questionTypeSort == false) {
    //         setQuestionLevelSort(null);
    //         setQuestionSort(null);
    //     }
    // }, [questionTypeSort])

    // useEffect(() => {
    //     if (questionSort == true || questionSort == false) {
    //         setQuestionLevelSort(null);
    //         setQuestionTypeSort(null);
    //     }
    // }, [questionSort])

    return (
        <>
            <Loader loading={loading} />
            <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                <div id='scroll-up'></div>
                <Header />
                <div className="container-fluid">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb my-0 ms-2">
                            <li className="breadcrumb-item dashboard" onClick={() => handleNavigate('/institute-dashboard')}>
                                <span>Dashboard</span>
                            </li>
                            <li className="breadcrumb-item active"><span>View Competitive Question Bank</span></li>
                        </ol>
                    </nav>
                </div>

                <div className="container-lg">
                    <div className="row">
                        <div className="card border-info mx-auto mt-3">
                            <div className="card-content collpase show">
                                <div className="card-header" style={{ backgroundColor: '#3081D0', borderRadius: 0 }}>
                                    <h4 className="text-white"><b><span className="fa fa-file-o"></span><i class="fa fa-eye"></i>VIEW COMPETITIVE QUESTION BANK</b></h4>
                                </div>
                                <div className="card-body ">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="row">

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Competitive Exam  Structure :</label>
                                                    <select required class="form-select" aria-label="Default select example" name='instituteCompetitiveExamNameMasterId' onChange={handleSyllabusChange} value={filter.instituteCompetitiveExamNameMasterId}>
                                                        <option selected value={''} disabled>Select Competitive Exam  Structure</option>
                                                        {
                                                            syllabusList?.map((syllabus) => {
                                                                return <option value={syllabus.id}>{syllabus?.examName}</option>
                                                            })
                                                        }
                                                    </select>
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Book :</label>
                                                    <select required class="form-select" aria-label="Default select example" name='instituteCompetitiveExamBookMasterId' onChange={handleBookChanges} value={filter.instituteCompetitiveExamBookMasterId}>
                                                        <option selected value={''} disabled>Select Book</option>
                                                        {
                                                            bookList?.map((syllabus) => {
                                                                return <option value={syllabus.id}>{syllabus.bookName}</option>
                                                            })
                                                        }
                                                    </select>
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Subject :</label>
                                                    <select class="form-select" aria-label="Default select example" name='instituteSubjectMasterId' onChange={handleSubjectChanges} value={filter.instituteSubjectMasterId}>
                                                        <option selected value={''} disabled>Select Subject</option>
                                                        {
                                                            subjectList?.map((syllabus) => {
                                                                return <option value={syllabus.instituteSubjectMasterDetails.id}>{syllabus.instituteSubjectMasterDetails.subjectName}</option>
                                                            })
                                                        }
                                                    </select>
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Lesson :</label>
                                                    <select required class="form-select" aria-label="Default select example" name='instituteCompetitiveLessonMasterId' onChange={handleLessonChange} value={filter.instituteCompetitiveLessonMasterId}>
                                                        <option selected value={''} disabled>Select Lesson</option>
                                                        {
                                                            lessonList?.map((lesson) => {
                                                                return <option value={lesson.id}>{lesson.competitiveLessonName}</option>
                                                            })
                                                        }
                                                    </select>
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Topic :</label>
                                                    <select required class="form-select" aria-label="Default select example" name='instituteCompetitiveTopicMasterId' onChange={handleTopicChange} value={filter.instituteCompetitiveTopicMasterId}>
                                                        <option selected value={''} disabled>Select Topic</option>
                                                        {
                                                            topicList?.map((topic) => {
                                                                return <option value={topic.id}>{topic.competitiveTopicName}</option>
                                                            })
                                                        }
                                                    </select>
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Sub Topic :</label>
                                                    <select required class="form-select" aria-label="Default select example" name='competitiveSubTopicName' onChange={handleInputFilterChange} value={filter.competitiveSubTopicName}>
                                                        <option selected value={''} disabled>Select Sub Topic</option>
                                                        {
                                                            subtopicList?.map((subtopic) => {
                                                                return <option value={subtopic.id}>{subtopic.competitiveSubTopicName}</option>
                                                            })
                                                        }
                                                    </select>
                                                </div>

                                                {!editId && <div className="col-md-12 mt-3 mb-1" style={{ textAlign: 'center' }}>
                                                    <div className="col-auto">
                                                        <button className="btn btn-outline-danger delete_icon" type="button" style={{ marginRight: '20px' }} onClick={handleReset}>Reset</button>
                                                    </div>
                                                </div>}

                                                {filter.instituteSubjectMasterId !== "" &&

                                                    <div className='row'>
                                                        <div className="separator"></div>
                                                        <div className="d-grid gap-2 mt-2">
                                                            {displayedData.length > 0 ?
                                                                <>
                                                                    <div className='search_btn_row'>
                                                                        <input
                                                                            className="form-control mr-sm-2"
                                                                            type="Search"
                                                                            placeholder="Search"
                                                                            value={searchValue}
                                                                            onChange={handleEmptySearch}
                                                                            onKeyDown={(event) => {
                                                                                if (event.key === 'Enter') {
                                                                                    handleSearch();
                                                                                }
                                                                            }}
                                                                        />
                                                                        <button className="btn btn-outline-primary" onClick={handleSearch}><i class="fa fa-search" aria-hidden="true"></i></button>
                                                                    </div>
                                                                    <div class="generate_pdf_question_paper_report_block" id="examReportContent">
                                                                        <div class="generate_pdf_question_paper_heading">
                                                                            <div class="generate_pdf_question_paper_logo">
                                                                                {/* <img src={displayedData[0]?.instituteMasterDetails?.logoPath} alt="Institute Logo" /> */}
                                                                                <img src={VidyaUpasnaLogo} alt="VidyaUpasna Logo" />
                                                                            </div>
                                                                            <div class="text_center">
                                                                                {/* <h6>{displayedData[0]?.instituteMasterDetails?.instituteName}</h6> */}
                                                                                {/* <h4>{displayedData[0]?.sectionMasterDetails?.sectionName}</h4> */}
                                                                                <h4>{instituteName}</h4>
                                                                            </div>
                                                                            <div class="generate_pdf_question_paper_logo">
                                                                                {/* <img src={displayedData[0]?.instituteMasterDetails?.logoPath} alt="Institute Logo" /> */}
                                                                                <img src={instituteLogo} alt="Institute Logo" />
                                                                            </div>
                                                                        </div>

                                                                        <div class="generate_pdf_question_paper_report_code">
                                                                            <span class="line"></span>
                                                                        </div>

                                                                        <div class="generate_pdf_question_paper_details">
                                                                            <span>Competitive Exam: {displayedData[0]?.instituteCompetitiveExamNameMasterDetails?.examName}</span>
                                                                            <span>Book: {displayedData[0]?.instituteCompetitiveExamBookMasterDetails?.bookName}</span>
                                                                            <span>Subject: {displayedData[0]?.instituteSubjectMasterDetails?.subjectName}</span>
                                                                            {/* <span>Lesson: {pdfDetails?.examTotalMarks}</span> */}
                                                                        </div>


                                                                        <ol className="generate_pdf_question_paper_generated_pdf_total_question">
                                                                            {displayedData?.map((question, index) => {
                                                                                return (
                                                                                    <>
                                                                                        {index == 0 && <div class="generate_pdf_question_paper_details">
                                                                                            <span>Lesson: {question?.instituteCompetitiveLessonMasterDetails?.competitiveLessonName}</span>
                                                                                        </div>}
                                                                                        {index !== 0 && (displayedData[index - 1].instituteCompetitiveLessonMasterId !== question.instituteCompetitiveLessonMasterId) && <div class="generate_pdf_question_paper_details">
                                                                                            <span>Lesson: {question?.instituteCompetitiveLessonMasterDetails?.competitiveLessonName}</span>
                                                                                        </div>}
                                                                                        <li key={index} className="generate_pdf_question_paper_question pdf-question-paper-listed-outer">
                                                                                            {/* <p>{question.question}</p> */}
                                                                                            {/* <p> */}
                                                                                            {/* <strong>{startIndex + index + 1}. </strong> */}
                                                                                            {/* <ViewImageAndTextQuetionBank inputString={question.question} onViewImage={onViewImage} /> */}
                                                                                            {/* </p> */}

                                                                                            <div className='card-question-header'>
                                                                                                <span className="list-number">{startIndex + index + 1}.</span>
                                                                                                <ViewImageAndTextQuetionBank inputString={question.question} onViewImage={onViewImage} />
                                                                                            </div>
                                                                                            <ul className='margin-top-10'>
                                                                                                {['option_a', 'option_b', 'option_c', 'option_d'].map((optionKey, optionIndex) => {
                                                                                                    const optionLetter = String.fromCharCode(65 + optionIndex); // A, B, C, D
                                                                                                    // const isCorrect = question.ans.split(',').includes(String.fromCharCode(97 + optionIndex)); // Checking if the answer matches
                                                                                                    return (
                                                                                                        <li key={optionIndex} data-option={optionLetter} /*className={isCorrect ? "correct" : ""}*/>
                                                                                                            {/* {question[optionKey]} */}
                                                                                                            <ViewImageAndTextQuetionBank inputString={question[optionKey]} onViewImage={onViewImage} />
                                                                                                        </li>
                                                                                                    );
                                                                                                })}
                                                                                            </ul>
                                                                                            <p className="pdf-highlight"><strong>Correct Answer:</strong> {question.ans.toUpperCase()}</p>
                                                                                            <p className="pdf-highlight"><strong>Solution:</strong><ViewImageAndTextQuetionBank inputString={question.sol} onViewImage={onViewImage} /></p>
                                                                                        </li>
                                                                                    </>
                                                                                )
                                                                            })}
                                                                        </ol>

                                                                    </div>
                                                                    <Pagination currPage={currPage} setCurrPage={setCurrPage} totalPages={totalPages} itemsPerPage={itemsPerPage} setItemsPerPage={setItemsPerPage} totalItem={questions.length} />
                                                                </>
                                                                :
                                                                (<div className='row'>
                                                                    <th colspan={"100%"} style={{ textAlign: 'center' }}>No Questions Available</th>
                                                                </div>)}
                                                        </div>
                                                    </div>

                                                }

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />

            {visible && <CModal
                visible={visible}
                onClose={() => setVisible(false)}
                aria-labelledby="LiveDemoExampleLabel"
                onIni
            >
                <div className="book book-modal">
                    <h2 className='table-header-like'> Solution</h2>

                    <div className="page" dangerouslySetInnerHTML={{
                        __html: `<style>.ckContent img{max-width:100% !important; height: auto !important}</style><div class="ck-content">${modalData}</div>`
                    }}></div>

                    <button className="btn btn-outline-warning edit_icon" type="button" onClick={() => setVisible(false)}>
                        Close
                    </button>
                </div>
            </CModal>}

            {visibleImage && (
                <CModal
                    visible={visibleImage}
                    onClose={() => setVisibleImage(false)}
                    aria-labelledby="LiveDemoExampleLabel"
                >
                    <div className="book book-modal">
                        <div className='table-header-like'>Image</div>
                        {modalImageSrc && <div className='page' dangerouslySetInnerHTML={{ __html: modalImageSrc }}></div>}
                        <button className="btn btn-outline-warning edit_icon" type="button" onClick={() => setVisibleImage(false)}>
                            Close
                        </button>
                    </div>
                </CModal>
            )}

        </>
    )
};

export default InstituteViewCompetitiveExam;
